import { Component, OnInit, AfterViewInit, ElementRef, Input, ViewChild } from '@angular/core';
import { WebRTCAdaptor } from '@antmedia/webrtc_adaptor';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-broadcast',
  templateUrl: './broadcast.component.html',
  styleUrls: ['./broadcast.component.css']
})
export class BroadcastComponent implements OnInit, AfterViewInit {
  @Input() auctionData: any
  @ViewChild('localVideo') localVideo!: ElementRef;

  webrtcAdaptor: any;


  // /* antmedia variable */
  token: any;
  pc_config: any = null;
  playStreamId: any;
  publishStreamId: any;
  sdpConstraintsPublish: any;
  mediaConstraintsPublish: any;
  publishWebRTCAdaptor: any;
  websocketURL!: string;
  room: any;
  showStream= false;
  closeStream=false;
  playVideo =false;
  constructor() {
    
    this.websocketURL = environment.streamUrlPlay;
    this.webrtcAdaptor = null;
   

    // ant media
    this.token = "";
    this.pc_config = null;

    //var path =  location.hostname + ":5443"+"/WebRTCAppEE/websocket";
    // let path = "phpmatrix.com:5443/WebRTCAppEE/websocket";

    // if (location.protocol.startsWith("https")) {
    //   this.websocketURL = "wss://" + path;
    // }
    // console.log("websocketURL", this.websocketURL);

    this.sdpConstraintsPublish = {
      OfferToReceiveAudio: true,
      OfferToReceiveVideo: true
    };

    this.mediaConstraintsPublish = {
      video: false,
      audio: false
    };

  }

  ngOnInit(): void {
    this.room = this.auctionData.id;
    //this.initWebrtc();

  }

  initWebrtc() {
    
    this.webrtcAdaptor = new WebRTCAdaptor({
      websocket_url: this.websocketURL,
      mediaConstraints : this.mediaConstraintsPublish,
      peerconnection_config:
      {
          'iceServers': [{'urls': 'stun:stun1.l.google.com:19302'}]
      },
      sdp_constraints : this.sdpConstraintsPublish,
      remoteVideoId : "localVideo",
      isPlayMode: true,
      callback : function(info:any) {
      
        if (info == "initialized") {
          // console.log("initialized");
         
        } else if (info == "play_started") {
          //play_started
          // console.log("play started");
          

        } else if (info == "play_finished") {
          // play finishedthe stream
          // console.log("play finished");
          
        }
      },
      callbackError: (error: any, message: any) => {
         //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError

        //  console.log("error callback: " + JSON.stringify(error));
         var errorMessage = JSON.stringify(error);
         if (typeof message != "undefined") {
           errorMessage = message;
         }
         var errorMessage = JSON.stringify(error);
         if (error.indexOf("NotFoundError") != -1) {
           errorMessage = "Camera or Mic are not found or not allowed in your device";
         }
         else if (error.indexOf("NotReadableError") != -1 || error.indexOf("TrackStartError") != -1) {
           errorMessage = "Camera or Mic is being used by some other process that does not let read the devices";
         }
         else if (error.indexOf("OverconstrainedError") != -1 || error.indexOf("ConstraintNotSatisfiedError") != -1) {
           errorMessage = "There is no device found that fits your video and audio constraints. You may change video and audio constraints"
         }
         else if (error.indexOf("NotAllowedError") != -1 || error.indexOf("PermissionDeniedError") != -1) {
           errorMessage = "You are not allowed to access camera and mic.";
         }
         else if (error.indexOf("TypeError") != -1) {
           errorMessage = "Video/Audio is required";
         }
         if (error.indexOf("publishTimeoutError") != -1) {
          //  console.log("publish timeout error caught, Correct Start stream label", error);
           this.webrtcAdaptor = null;
           this.initWebrtc();
         }
 
        //  console.log(errorMessage);
      }
    });
  }
  muteLocalMic(){
    this.webrtcAdaptor.muteLocalMic();
  }
  play(){
    //this.muteLocalMic();
    this.webrtcAdaptor.play(this.auctionData.stream_id,this.auctionData.stream_play_token);

  }
  // initStreaming(){
  //   this.initWebrtc();
    
  // }

  ngAfterViewInit(): void {
     this.initWebrtc();
    // this.webrtcAdaptor.play(this.auctionData.id,'');
    this.webrtcAdaptor.play(String(this.auctionData.stream_id),String(this.auctionData.stream_play_token));
    this.muteLocalMic();
  }
}